<template>
  <div class="person-center-user-info">
    <img :src="require('@assets/ic_user_portrait.png')" alt />
    <div>
      <div>
        <h4>{{ userInfo.patientName }}</h4>
        <span>{{ userInfo.cardNo }}</span>
        <span @click="changeCard" class="person-center-user-info-card-type">{{
          getCardType
        }}</span>
      </div>
      <div>
        <span>预交金</span>
        <span>¥ {{ userInfo.prepay }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    userInfo: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    getCardType() {
      let cardType = "";
      if (this.userInfo.cardType === "0") {
        cardType = "就诊卡";
      } else if (this.userInfo.cardType === "1") {
        cardType = "社保卡";
      } else if (this.userInfo.cardType === "2") {
        cardType = "住院号";
      }
      return cardType;
    }
  },
  methods: {
    changeCard() {
      this.$router.push({
        name: "change-card",
        query: {
          ftype: this.userInfo.cardType === "2" ? "2" : "1"
        }
      });
    }
  }
};
</script>

<style lang="less">
.person-center-user-info {
  display: flex;
  margin-top: 3.5rem;
  img {
    width: 3rem;
    height: 3rem;
    margin-left: 1rem;
    border-radius: 50%;
  }

  > div {
    margin-left: 0.8rem;
    color: white;
    > div {
      display: flex;
      align-items: center;

      h4 {
        margin: 0;
        margin-right: 0.8rem;
        font-size: 0.9rem;
      }

      span {
        margin-right: 0.8rem;
      }
    }
  }

  &-card-type {
    margin-left: 0.4rem;
    padding: 0.1rem 0.4rem;
    color: #fff;
    font-size: 0.8rem;
    border: solid 1px #fff;
    border-radius: 4px;
    opacity: 0.8;
  }
}
</style>
